import React from "react";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

const WA_NUMBER = "917276863734";
const WA_MESSAGE =
  "Hello Rahilaxmi Exports, I'm interested in your products. Please share more details.";

export const WhatsAppFab = () => {
  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed z-[60] bottom-6 right-6 md:bottom-8 md:right-8 flex items-center gap-3 group"
      initial={{ opacity: 0, scale: 0.6, y: 30 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 20 }}
    >
      {/* Tooltip label */}
      <span
        className="hidden md:inline-flex items-center bg-[#0A192F] text-white text-xs font-semibold tracking-wider uppercase px-4 py-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
        style={{ letterSpacing: "0.14em" }}
      >
        Chat on WhatsApp
      </span>

      {/* Ping ring */}
      <span className="relative inline-flex">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
        <span className="relative inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-[0_10px_30px_-6px_rgba(37,211,102,0.55)] ring-2 ring-white/70 group-hover:scale-105 transition-transform">
          <WhatsAppGlyph className="w-7 h-7 md:w-8 md:h-8 text-white" />
        </span>
      </span>
    </motion.a>
  );
};

const WhatsAppGlyph = ({ className = "" }) => (
  <svg
    viewBox="0 0 32 32"
    aria-hidden="true"
    className={className}
    fill="currentColor"
  >
    <path d="M19.11 17.24c-.29-.15-1.7-.84-1.96-.94-.26-.1-.45-.15-.65.15-.19.29-.75.94-.92 1.13-.17.19-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.15-.24-.57-.48-.49-.65-.5h-.55c-.19 0-.5.07-.77.36-.26.29-1.01.99-1.01 2.41 0 1.42 1.03 2.79 1.18 2.98.15.19 2.04 3.12 4.94 4.37.69.3 1.23.48 1.65.62.69.22 1.32.19 1.82.12.55-.08 1.7-.7 1.94-1.37.24-.67.24-1.24.17-1.37-.07-.13-.26-.19-.55-.34zM16.02 5.33c-5.93 0-10.75 4.82-10.75 10.75 0 1.9.5 3.76 1.44 5.4L5.2 27l5.66-1.48a10.72 10.72 0 0 0 5.16 1.32h.01c5.93 0 10.75-4.82 10.75-10.75s-4.83-10.76-10.76-10.76zm0 19.7h-.01a8.95 8.95 0 0 1-4.55-1.25l-.33-.19-3.36.88.9-3.27-.21-.34a8.94 8.94 0 1 1 16.51-4.78 8.95 8.95 0 0 1-8.95 8.95z" />
  </svg>
);

export default WhatsAppFab;
